import React, { useEffect, useLayoutEffect, useState } from "react";
import { Box, Typography, Grid, Container } from "@mui/material";

import SideNav from "../../components/faq/SideNav";
import Questions from "../../components/faq/Questions";

import "./faq.scss";
import { getFAQ } from "../../services/faq";

const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeKey, setActiveKey] = useState("");
  const fetchFAQ = async () => {
    const result = await getFAQ();
    if (result?.success) {
      setFaqs(result?.payLoad);
      setActiveKey(result?.payLoad[0]?.translationKey);
    }
  };
  useLayoutEffect(() => {
    fetchFAQ();
  }, []);

  const sideNavProps = {
    activeKey,
    setActiveKey,
    faqs,
  };
  const questionsProps = {
    activeKey,
    faqs,
  };
  return (
    <Box className="faq-page">
      <Container>
        <Grid container spacing={2}>
          <Grid item lg={3} sm={4} xs={12}>
            <SideNav {...sideNavProps} />
          </Grid>
          <Grid item lg={9} sm={8} xs={12}>
            <Questions {...questionsProps} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Faq;
